export default "__VITE_ASSET__Cx86h9bF__"